import { request } from '../../../global/services/request'

export async function getAccountSearchResults(
  partnerId: string,
  text: string,
  includeDeactivated: boolean,
  limit: number,
  page: number
) {
  const qryParams = {
    'filter': `name~=${text}`,
    'role': 'employee',
    'limit': `${limit}`,
    'page': `${page}`,
    'sort' : 'name',
    'include': 'subscription,latest_activity,stats' + (includeDeactivated ? ',deactivated' : '')
  }

  return await request({
    path: `/resellers/${partnerId}/accounts?${new URLSearchParams(qryParams)}`,
    method: 'get'
  })
}

export async function getFiltersForAccount(accountId: string) {
  return await request({
    path: `/accounts/${accountId}/filters?limit=100&include=count`,
    method: 'get'
  })
}

